import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";

const serviceList = [
  { id: 0, name: "all", value: "All" },
  { id: 1, name: "internal", value: "Internal" },
  { id: 2, name: "external", value: "External" },
];

const ServiceFilter = (props) => {
  const { service, setService } = props;

  const handleDropDownValue = (event) => {
    setService(event.target.value);
  };

  return (
    <div>
      <Typography
        variant="subtitle1"
        style={{
          fontWeight: "bold",
          lineHeight: "1.75rem",
          color: "#EF7000",
        }}
      >
        Service
      </Typography>
      <br />
      <Select
        labelId="service"
        defaultValue={service}
        id="service"
        name="service"
        variant="outlined"
        onChange={handleDropDownValue}
        placeholder="Service"
        style={{ width: "235px", height: "45px" }}
        value={service}
      >
        {serviceList.map((data, index) => {
          return (
            <MenuItem name={data.name} key={index} value={data.name}>
              <Typography variant="h2">{data.value}</Typography>
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export default ServiceFilter;
